import { render } from "./app-system-dialog.vue?vue&type=template&id=3774d318&ts=true"
import script from "./app-system-dialog.vue?vue&type=script&lang=ts"
export * from "./app-system-dialog.vue?vue&type=script&lang=ts"

import "./app-system-dialog.vue?vue&type=style&index=0&id=3774d318&lang=scss"

import exportComponent from "D:\\shine\\shine-project\\dispatch-big-screen-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__